import React from 'react';
import Spoiler from '~c/ui/Spoiler';
import { ProfileContext } from '../../dataProvider';
import Loader, { spinnerPositions, spinnerStates } from '~c/ui/Loader';
import { prepareInput, splitInputsByRenderBlock } from '~p/EventReg/InputRegCourse';
import { companyInputs } from './CompanyInputs';
import { getCityNameByKLDARwithDadata } from '~h/cityCodes';

class Company extends React.PureComponent {
  state = {
    inputs: companyInputs,
    isEditable: false,
    spinnerState: spinnerStates.done,
    buttonLabel: 'Редактировать',
    errorMessage: null,
  };

  async componentDidMount() {
    const newCompany = { ...this.props.company };

    if (newCompany?.cityCode && newCompany.cityCode !== '') {
      newCompany.city = await getCityNameByKLDARwithDadata(newCompany.cityCode);
      const { updateCompany } = this.context;
      updateCompany(newCompany);
    }
  }

  renderCompanyHeader = name => {
    return (
      <div className="member member--spoiler">
        <div className="member__inner">
          <p className="member__name">{name}</p>
        </div>
      </div>
    );
  };

  changeInput = (name, value, dadataValue = null) => {
    const newCompany = { ...this.props.company };

    if (dadataValue && dadataValue.typeOfEntity === 'company') {
      newCompany.companyName = dadataValue.value;
      newCompany.inn = dadataValue.data.inn;
      newCompany.kpp = dadataValue.data.kpp;
      newCompany.city = dadataValue.data.address.data.city;
      newCompany.cityCode = dadataValue.data.address.data.city_kladr_id;
      newCompany.address = dadataValue.data.address.unrestricted_value;
      newCompany.factAddress = dadataValue.data.address.unrestricted_value;
    }
    if (dadataValue && dadataValue.typeOfEntity === 'bank') {
      newCompany.bankBik = dadataValue.data.bic;
      newCompany.bankName = dadataValue.value;
      newCompany.paymentCorAccount = dadataValue.data.correspondent_account;
    }

    if (dadataValue && dadataValue.typeOfEntity === 'city') {
      newCompany.cityCode = dadataValue.city_kladr_id;
    }

    newCompany[name] = value;

    const { updateCompany } = this.context;
    updateCompany(newCompany);
  };

  validateInput = () => {};

  renderInputs = inputs =>
    inputs.map((block, index) => (
      // eslint-disable-next-line
      <div className="inp-wrap" key={index}>
        {block?.map(input =>
          prepareInput({
            ...input,
            disabled: !this.state.isEditable,
            value: this.props.company[input.name],
            onChangeCallback: this.changeInput,
            onBlurCallback: this.validateInput,
          }),
        )}
      </div>
    ));

  renderCompanyData = company => {
    const { isEditable, inputs, buttonLabel, errorMessage } = this.state;
    const { updateCompany, saveCompany } = this.context;
    const buttonClass = isEditable
      ? 'btn btn--primary profile__btn'
      : 'btn btn--outline profile__btn';

    const splittedCompanyInputs = splitInputsByRenderBlock(inputs);

    return (
      <div className="registration">
        {this.renderInputs(splittedCompanyInputs)}
        <button
          className={buttonClass}
          type="submit"
          onClick={async () => {
            if (!isEditable) {
              const lastCompany = { ...this.props.company };
              this.setState({
                lastCompany,
                buttonLabel: 'Сохранить',
                isEditable: !this.state.isEditable,
              });
            } else {
              this.setState({
                errorMessage: null,
                spinnerState: spinnerStates.pending,
              });

              const errors = await saveCompany(company);
              if (!errors) {
                this.setState({
                  buttonLabel: 'Сохранено успешно',
                  isEditable: !this.state.isEditable,
                  errorMessage: errors,
                  spinnerState: spinnerStates.done,
                });
              } else {
                this.setState({
                  errorMessage: errors,
                  spinnerState: spinnerStates.done,
                });
              }
            }
          }}
        >
          {this.state.spinnerState === spinnerStates.done ? (
            buttonLabel
          ) : (
            <React.Fragment>
              <div className="invisible">Сохранить</div>
              <Loader
                spinnerState={this.state.spinnerState}
                spinnerPosition={spinnerPositions.absolute}
                style={{
                  color: 'white',
                }}
              />
            </React.Fragment>
          )}
        </button>

        {isEditable && (
          <button
            type="button"
            className="btn btn--outline profile__btn"
            onClick={() => {
              const { lastCompany } = this.state;
              const newCompany = Object.assign({}, lastCompany);
              updateCompany(newCompany);
              this.setState({
                isEditable: false,
                buttonLabel: 'Редактировать',
                errorMessage: null,
              });
            }}
          >
            Отменить
          </button>
        )}

        {errorMessage !== '' ? (
          <div className="inp-wrap">
            <div className="error error--red">{errorMessage}</div>
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    const { company } = this.props;
    return (
      <Spoiler
        key={`key-${company.id}`}
        header={this.renderCompanyHeader(company.companyName)}
        content={this.renderCompanyData(company)}
        disabled={this.state.isEditable}
      />
    );
  }
}

Company.contextType = ProfileContext;

export default Company;
